import { LocationFilters } from '@hakimo-ui/hakimo/types';
import { FilterItem } from '../location-list/util';

export const UPDATE_FILTERS = 'UPDATE_FILTERS';
export const UPDATE_PAGE = 'UPDATE_PAGE';
export const UPDATE_SEARCH_VALUE = 'UPDATE_SEARCH_VALUE';
export const UPDATE_SELECTED_FILTER = 'UPDATE_SELECTED_FILTER';

export interface UpdateFiltersAction {
  type: typeof UPDATE_FILTERS;
  payload: LocationFilters;
}

export interface UpdatePageAction {
  type: typeof UPDATE_PAGE;
  payload: number;
}

export interface UpdateSearchValueAction {
  type: typeof UPDATE_SEARCH_VALUE;
  payload: string;
}

export interface UpdateSelectedFilterAction {
  type: typeof UPDATE_SELECTED_FILTER;
  payload: FilterItem;
}

export type Action =
  | UpdateFiltersAction
  | UpdatePageAction
  | UpdateSearchValueAction
  | UpdateSelectedFilterAction;
